import { api } from "./client.js";

export type NotificationKind =
  | "connection_request"
  | "connection_accepted"
  | "still_here"
  | "arriving_in_your_city";

export interface Notification {
  id: string;
  kind: NotificationKind;
  actor_id: string | null;
  entry_id: string | null;
  body: string | null;
  read_at: string | null;
  created_at: string;
}

export const notificationsApi = {
  list: () => api.get<{ notifications: Notification[]; unread: number }>("/api/notifications"),
  unreadCount: () => api.get<{ unread: number }>("/api/notifications/unread-count"),
  markRead: (id: string) => api.post<{ ok: boolean }>(`/api/notifications/${id}/read`),
  markAllRead: () => api.post<{ ok: boolean }>("/api/notifications/read-all"),
};
